export default "__VITE_ASSET__DFLtzd2F__"